type ResolvedConversationViewProps = {
  onStartNew: () => void;
  starting?: boolean;
};

export function ResolvedConversationView({
  onStartNew,
  starting = false,
}: ResolvedConversationViewProps) {
  return (
    <div className="rw-resolved">
      <div className="rw-resolved-copy">
        <div className="rw-resolved-title">This discussion has ended.</div>
        <div className="rw-resolved-subtitle">
          You can review previous messages or start a new conversation.
        </div>
      </div>
      <button
        type="button"
        className="rw-resolved-cta"
        onClick={onStartNew}
        disabled={starting}
      >
        {starting ? 'Starting…' : 'Start New Conversation'}
      </button>
    </div>
  );
}
